var scope_0 = require('/Users/alex/Projects/Code/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0bf427068236223061aea3c4b46c2e87.js').default;
var scope_1 = require('/Users/alex/Projects/Code/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2b8b9dd6f2b818d803b65fc1bac8e61c.js').default;
var scope_2 = require('/Users/alex/Projects/Code/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c97092faad7d57c2a1f6925637ec34e9.js').default;
var scope_3 = require('/Users/alex/Projects/Code/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d57aab7351e48e7c2dc1ca9cd9250568.js').default;
var scope_4 = require('/Users/alex/Projects/Code/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_5 = require('/Users/alex/Projects/Code/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f4286efe711b49a2dc76ae156ab95afe.js').default;
var scope_6 = require('/Users/alex/Projects/Code/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f983811f2b309c5afa1ae25248555578.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6 )
    